import { UserRole, type GetRolesResponseBody } from "@eisox/api/core-api";

import type { Permission } from "~/types/auth.type";

import { installerPermissions } from "./permissions/installer.constant";
import { managerBoilerRoomPermissions } from "./permissions/manager-boiler-room.constant";
import { managerPermissions } from "./permissions/manager.constant";
import { ownerPermissions } from "./permissions/owner.constant";
import { visitorPermissions } from "./permissions/visitor.constant";

export const getPermissions = (
  roles: GetRolesResponseBody,
  buildingId: string,
): { permissions: Permission; role: UserRole } => {
  const rolePermissions: Record<UserRole, Permission> = {
    [UserRole.INSTALLER]: installerPermissions,
    [UserRole.OWNER]: ownerPermissions,
    [UserRole.MANAGER]: managerPermissions,
    [UserRole.MANAGER_BOILER_ROOM]: managerBoilerRoomPermissions,
    [UserRole.VISITOR]: visitorPermissions,
    [UserRole.API]: {},
  };
  const role = Object.entries(roles).find(([_, buildings]) => buildings.includes(buildingId))?.[0] as
    | UserRole
    | undefined;
  return {
    permissions: role ? rolePermissions[role] : {},
    role: role ?? UserRole.VISITOR,
  };
};
